<agpr-take-over-panel
    [id]="'g2_review'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    class="g2Review-dialog"
    header="Core.navigation.support.review"
    [width]="80"
    (visibleChange)="cancel()"
>
    <div
        [agprLoading]="!url"
        class="g2Review-dialogContent"
    >
        <iframe
            id="g2_review_iframe"
            *ngIf="url"
            [src]="url | agprBypassURLSecurity"
            style="width: 100%; height: 100%;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
        ></iframe>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="cancel"
            (click)="closeDialog()"
            [style]="buttonTypesEnum.secondary"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
